<template>
  <vs-col vs-type="flex" vs-align="flex-end" vs-w="7">
    <v-select
      class="sdf-text-16-400-white style-chooser w-full ml-4 mb-8"
      v-model="selectedVessel"
      :options="options"
      :clearable="false"
      :searchable="false"
    />
  </vs-col>
</template>

<script>
import vSelect from "vue-select";
import SecureDataflowService from "@/services/secureDataflowService";

// mixins
import {
  MappingTableMixin,
  StoreCommonsMixin,
  StoreMonitoringVesselManeuveringMixin
} from "@/mixins/addon/secure-dataflow";

export default {
  mixins: [
    MappingTableMixin,
    StoreCommonsMixin,
    StoreMonitoringVesselManeuveringMixin
  ],
  components: {
    vSelect
  },
  data() {
    return {
      options: [],
      isReset: false,
      selectedVessel: null,
      maneuveringOriginId: 2,
      engineOriginId: 1,
      alertOriginId: 1
    };
  },
  watch: {
    ownVessels(newVal, oldVal) {
      newVal.forEach((v, i) => {
        this.options.push({
          label: v.name_ja !== null ? v.name_ja : v.name,
          index: i,
          vesselId: v.id
        });
      });
      if (oldVal) {
        this.setVessel(false);
      } else {
        this.setVessel(true);
      }
    },
    selectedVessel(newVal, oldVal) {
      if (oldVal) {
        this.switchVessel(oldVal);
      }
    }
  },
  computed: {},
  methods: {
    async setVessel(isInit) {
      let vessel = await SecureDataflowService.getVessel();
      if (typeof vessel !== "undefined") {
        this.selectedVessel = this.options.find(
          ({vesselId}) => vesselId === vessel.vessel_info.id
        );
        if (!isInit) {
          let payload = {
            vesselInfo: vessel.vessel_info,
            maneuveringOriginId: vessel.maneuvering_origin_id,
            engineOriginId: vessel.engine_origin_id,
            alertOriginId: vessel.alert_origin_id
          };
          await this.setVesselInfoAndVersions(payload);
          await this.setChannelMaster({
            vesselId: vessel.vessel_info.id,
            params: {
              version_id: this.engineVersion.id
            }
          });
        }
      }
    },
    async switchVessel(beforeVessel) {
      if (this.isReset) {
        this.isReset = false;
        return;
      }
      this.$vs.loading({
        container: "#secure-dataflow-live-map",
        scale: 0.6
      });
      let payload = {
        vesselInfo: this.ownVessels[this.selectedVessel.index],
        maneuveringOriginId: this.maneuveringOriginId,
        engineOriginId: this.engineOriginId,
        alertOriginId: this.alertOriginId
      };
      let res = await this.setVesselInfoAndVersions(payload);

      if (!res.status) {
        this.$vs.notify({
          title: `船舶データの取得失敗`,
          text: `船舶名：${this.selectedVessel.label}(${this.selectedVessel.vesselId})<br>エラーコード：${res.data.error_code}<br>メッセージ：${res.data.message}`,
          color: "danger",
          fixed: true
        });
        this.isReset = true;
        this.selectedVessel = beforeVessel;
      }

      this.$vs.loading.close("#secure-dataflow-live-map > .con-vs-loading");
    }
  },
  mounted() {
  },
  beforeDestroy() {
  }
};
</script>

<style lang="scss"></style>
